module.exports = __webpack_public_path__ + "img/public/SiteIcons/check.svg?edde892f";